import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'
import { roundedCorners } from '@utils'

export const CaseStudiesMain = styled.section`
  background-color: ${colors.white};
`

export const CaseStudiesWrapper = styled.div``

export const CaseStudiesHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  a {
    margin-bottom: 15px;
  }
`

export const CaseStudiesFooter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  a span {
    ${mq.mobileMax} {
      font-size: 20px;
      letter-spacing: normal;
    }
  }
`

export const CaseStudiesTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading3Sans, textStylesConfig.heading2Serif)}
  max-width: 30rem;
  margin-right: auto;
  ${mq.tabletL} {
    max-width: 70rem;
  }
  ${mq.tabletPMax} {
    font-size: 28px;
  }
  a {
    margin-bottom: 15px;
  }
`

export const CaseStudiesNav = styled.ul`
  display: flex;
  list-style: none;

  ${mq.tabletLMax} {
    display: none;
  }
  button {
    > div {
      background: ${colors.white} !important;
      color: ${colors.charcoal} !important;
      border: 1px solid ${colors.charcoal} !important;
      border-radius: 7rem;
    }
    &:not(:disabled):hover > div {
      background: ${colors.charcoal} !important;
      color: ${colors.white} !important;
      border: 1px solid ${colors.charcoal}  !important;
    }

    &:disabled > div {
      opacity: 0.5;
    }
  }
`

export const CaseStudiesNavItem = styled.li`
  & + & {
    margin-left: 1rem;
  }
`

export const CaseStudiesCarousel = styled.div`
  display: flex;
  width: fit-content;
  transform: ${props => props.centered ? 'unset !important' : ''};
  min-width: ${props => props.centered ? '100%' : ''};
`

export const CaseStudiesCardWrapper = styled.div`
  &:not(:first-child) {
    ${clamp('padding-left', 20, 40)}
  }
  .mOnly {
    br {
      display: none;
      + *{
        margin-left: 5px;
      }
    }
    p {
      font-size: 17px;
    }
    ${mq.tabletL} {
      display: none;
    }
  }
  .dOnly {
    ${mq.tabletLMax} {
      display: none;
    }
  }
`

export const CaseStudyMain = styled.div`
    ${clamp('min-width', 255,  550)};
    ${({ $fixedWidth }) => ($fixedWidth ?  `width: ${$fixedWidth / 3}px` :  clamp('width', 255,  475))};
    aspect-ratio: 1 / 1;
    position: relative;
    ${roundedCorners}
    ${mq.tabletLMax} {
      margin-bottom: 10px;
    }
    
    a {
        text-decoration: none;
        width: 100%;
        height: 100%;
        &:before {
            position: absolute;
            content: "";
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 1;
        }
    }
    &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0,0,0,0.5);
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: all 0.25s ease;
    }
    .content {
        opacity: 0;
        color: ${colors.white};
    }
    &:hover {
        &:after {
            opacity: 1;
        }
        .content {
            opacity: 1;
        }
    }
    .caseStudyImage {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .gatsby-image-wrapper {
        position: absolute;
        height: 100% !important;
        min-width: 100%;
    }
`

export const CaseStudyImage = styled.div`
  
`

export const CaseStudyContent = styled.div`
    position: relative;
    z-index: 1;
    
    padding: 40px 30px;
    p {
        line-height: 30px;
    }
    transition: all 0.25s ease;
    h4 {
      ${clamp('font-size', 17,  26)};
      strong {
        font-family: inherit;
        font-weight: normal;
      }
    }
    h2 {
      ${clamp('font-size', 17,  26)};
      margin-bottom: 10px;
    }
    br {
      display: none;
      + * {
        margin-left: 5px;
      }
    }
`

export const CaseStudyContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-end;
    position: relative;
`